import React from "react";
import { ReactComponent as LogoSVG } from "../assets/logo.svg";
import { ReactComponent as LogoSmallSVG } from "../assets/logo_ZG_only.svg";

const Logo = React.memo(LogoSVG);
const LogoSmall = React.memo(LogoSmallSVG);

export const LogoPage = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-white">
            <Logo className="h-32 w-auto drop-shadow-md" />
        </div>
    );
};

export const LogoSmallPage = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-white">
            <LogoSmall className="h-32 w-auto drop-shadow-md" />
        </div>
    );
};

export default LogoPage;
